import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Props {
    open: boolean
}

const initialState: Props = {
    open: false
};

const modalStateSlice = createSlice({
    name: 'modalState',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload
        },
    },
});

export const { setOpen } = modalStateSlice.actions;
export default modalStateSlice.reducer;
